import { ApolloLink } from "@apollo/client";
import type { createUploadLink as UploadLinkType } from "apollo-upload-client";

import { graphqlWsLink, hasSubscriptionOperation } from "@shared/data/client/links/graphqlWsLink";
import { getUploadLink } from "@shared/data/client/links/uploadLink";

const createClientHttpLink = (uploadLinkOptions?: UploadLinkType.UploadLinkOptions) => {
  const uploadLink = getUploadLink(uploadLinkOptions);

  return ApolloLink.split(hasSubscriptionOperation, graphqlWsLink, uploadLink);
};

export { createClientHttpLink };
